<template src="./role_form.html"></template>

<script>
import { CreateRole } from '@/api/auth'

export default {
  name: 'add-role',
  data: function () {
    return {
      model: {
        role: '',
        note: ''
      },
      ruleValidate: {
        role: [{
          required: true,
          message: '必须填写角色名称',
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      CreateRole(this.model).then(async res => {
        if (res.role) {
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
